import { isMarketing } from '../marketing/marketingAccessPolicy';
import type { AuthPermissionUser } from '../../services/authPermissions';

export function isTesterMode(user: AuthPermissionUser | null | undefined): boolean {
  return user?.role === 'TESTER';
}

export function canViewProductionDataLists(user: AuthPermissionUser | null | undefined): boolean {
  return !isTesterMode(user) && !isMarketing(user);
}
